import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <Link to="/privacy-policy" className="footer-link">Privacy</Link>
        <a href="mailto:web3andai@gmail.com" className="footer-link">Contact</a>
      </div>
    </footer>
  );
}

export default Footer;
